/* eslint-disable max-len */
import { createSvgIcon } from '../utils'

// SVG - 14 width, 8 height

const ArrowDown = createSvgIcon(
    <path d="M.264.464a.9.9 0 0 1 1.272 0L6.9 5.827 12.264.464a.9.9 0 0 1 1.272 1.272l-6 6a.9.9 0 0 1-1.272 0l-6-6a.9.9 0 0 1 0-1.272z" />,
    'ArrowDown'
)

export default ArrowDown
